import { useState } from "react";
import { useNavigate } from "react-router-dom";

const CreateProjectTemplate = () => {
  const navigate = useNavigate();

  const [newProj, setNewProj] = useState({
    src: "",
    link: "",
    youtube: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  // Function to extract YouTube video ID
  const getYouTubeVideoId = (url) => {
    const regExp = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : null; // Return the video ID or null if not valid
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewProj((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // If the field is youtube, extract the video ID and generate the src
    if (name === "youtube") {
      const videoId = getYouTubeVideoId(value);
      if (videoId) {
        setNewProj((prevData) => ({
          ...prevData,
          src: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`, // Generate thumbnail URL
        }));
      } else {
        setNewProj((prevData) => ({
          ...prevData,
          src: "", // Clear thumbnail if the link is invalid
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const createProjPasswordResponse = await fetch("https://albiemer.onrender.com/api/check_password/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password: newProj.password }),
      });

      const passwordData = await createProjPasswordResponse.json();

      if (!createProjPasswordResponse.ok || !passwordData.isValid) {
        alert("Incorrect Password, Please try Again");
        setIsLoading(false);
        return;
      }

      const response = await fetch("https://albiemer.onrender.com/api/create_project/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newProj),
      });

      if (response.ok) {
        alert("Project created successfully!");
        setNewProj({ src: "", link: "", youtube: "", password: "" });
        navigate("/project");
      } else {
        alert("Error creating project");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-container">
      <div className="form-card">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="link"
            placeholder="Project Link"
            value={newProj.link}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="youtube"
            placeholder="YouTube Video Link"
            value={newProj.youtube}
            onChange={handleChange}
            required
          />
          
          {/* Display the image preview of YouTube thumbnail */}
          {newProj.src && (
            <div className="image-preview">
              <h3>Image Preview:</h3>
              <img src={newProj.src} alt="YouTube Thumbnail" style={{ width: "100%", maxWidth: "300px" }} />
            </div>
          )}

          <input
            type="password"
            name="password"
            placeholder="Admin Password to Post Project"
            value={newProj.password}
            onChange={handleChange}
            required
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Submitting..." : "Submit"}
          </button>
          <p>Password entered: {newProj.password}</p>
        </form>
        {isLoading && <div className="loading-spinner">Loading... Please wait</div>}
      </div>
    </div>
  );
};

export default CreateProjectTemplate;
